import {Routes} from '@angular/router'
import {authGuard} from './application/auth.guard'
import {LOGIN_PATH} from './application/types'
import {LoginComponent} from './components/login/login.component'
import {HomeComponent} from './messages/home/home.component'
import {ReadMessageComponent} from './messages/read-message/read-message.component'

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard]
  },
  {
    path: `home/:id`,
    component: ReadMessageComponent,
    canActivate: [authGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]